import { Action, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { BuffetAction, BuffetState } from "@/components/buffet/types";

export const actions: ActionTree<BuffetState, RootState> &
  Record<BuffetAction, Action<BuffetState, RootState>> = {};
